// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content__RDrOfBRh{padding:12px;width:300px}.content__RDrOfBRh .type-select__EcxXU1z4{width:100%}.content__RDrOfBRh .weights-section__CjowMPRv{display:flex;gap:16px;margin-top:8px}.content__RDrOfBRh .validation-error__NeTrTk5g{color:var(--orange1);font-size:12px;margin-top:16px}.content__RDrOfBRh .footer-section__3k6akoGm{display:flex;gap:8px;justify-content:flex-end;margin-top:20px}.content__RDrOfBRh .custom-name-input__TYfqEeWN{margin-top:8px}.dropdown-content__CCGilmVq{color:var(--primary-text-color);padding:16px;width:223px}.dropdown-content__CCGilmVq .dropdown-title__wE7kitK7{font-size:14px;margin-bottom:8px}.dropdown-content__CCGilmVq .dropdown-description__ONeX0arO{color:var(--secondary-text-color);font-size:12px;font-weight:400}.dropdown-content__CCGilmVq .dropdown-action__L24sA1gW{margin-top:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "content__RDrOfBRh",
	"typeSelect": "type-select__EcxXU1z4",
	"weightsSection": "weights-section__CjowMPRv",
	"validationError": "validation-error__NeTrTk5g",
	"footerSection": "footer-section__3k6akoGm",
	"customNameInput": "custom-name-input__TYfqEeWN",
	"dropdownContent": "dropdown-content__CCGilmVq",
	"dropdownTitle": "dropdown-title__wE7kitK7",
	"dropdownDescription": "dropdown-description__ONeX0arO",
	"dropdownAction": "dropdown-action__L24sA1gW"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
